import { Box, Breadcrumbs, Divider, MenuItem, Typography } from '@mui/material'
import { icons } from '../../../constants/images'
import FilterSelect from '../../../component/select/filterSelect'
import ButtonCustom from '../../../component/button/buttonCustom'
import { useCallback, useEffect, useState } from 'react'
import { LayoutTitle, LayoutView, TitleText } from '../../../component/layout/layoutMainStyle'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import GridViewIcon from '@mui/icons-material/GridView';
import { DialogCreate } from '../dialog/dialogCreate'
import DialogPermis from '../dialog/dialogPermis'
import DialogFilter from '../dialog/dialogFilter'
import DialogDetail from '../dialog/dialogDetail'
import DialogOpenFile from '../dialog/dialogOpenFile'
import DialogUpload from '../dialog/dialogUpload'
import FolderApi from '../../../api/folder/folder.api'
import { swalActive, swalError, swalSuccess } from '../../../component/notification/swal'
import FileApi from '../../../api/file/file.api'
import { useSelector } from 'react-redux'
import saveAs from 'file-saver'
import { useLocation } from 'react-router-dom'
import Folder from '../../../component/folder/folder'
import FilterFolder from '../../../component/folder/filterFolder'
import DialogIndex from '../dialog/dialogIndex'
import MenuButtom from '../../../component/memuButtons/menuButtom'
const initStateErrorMessage = {
    FOLDERNAME: "",
};
export default function SharedDocuments() {
    const { profile } = useSelector((state: any) => state.profile)
    const permit = profile?.permission || []

    const location = useLocation()
    const folderPath = location?.state?.folderPath || []
    const [openFilter, setOpenFilter] = useState<boolean>(false);

    const [errorMessage, setErrorMessage] = useState<any>(initStateErrorMessage);
    const clearErrorMessage = () => setErrorMessage(initStateErrorMessage);
    const [sort, setSort] = useState<string>('NAME_ASC')
    const [sortBy, setSortBy] = useState<string>('name')
    const [sortType, setSortType] = useState<string>('ASC')
    const [file, setFile] = useState<any>();
    const [files, setFiles] = useState<any>();

    const [inputFolder, setInputFolder] = useState<any>({
        folderName: '',
        folderLocation: '',
        idFiscalYear: null,
        idDepartment: null,
        idReferFolder: null,
        stepView: 1
    })
    const [level1, setLevel1] = useState<any>({
        detailFiles: [],
        detailFolders: []
    })
    const [level2, setLevel2] = useState<any>()
    const [level3, setLevel3] = useState<any>()
    const [level4, setLevel4] = useState<any>()
    const [keywordLevel1, setKeywordLevel1] = useState<string>('')
    const [keywordLevel2, setKeywordLevel2] = useState<string>('')
    const [keywordLevel3, setKeywordLevel3] = useState<string>('')
    const [keywordLevel4, setKeywordLevel4] = useState<string>('')
    const [levelfiles, setLevelFiles] = useState<any>()
    const [viewType, setViewType] = useState<string>('column')
    const [sdate, setSdate] = useState<string>('');
    const [edate, setEdate] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingFile, setLoadingFile] = useState<boolean>(false);
    const [step, setStep] = useState<any>([0, 0, 0, 0, 0]);
    const [stepView, setStepView] = useState<any>(1);
    const [folderName, setFolderName] = useState<any>();
    const [idFiscalYear, setIdFiscalYear] = useState<string>('');
    const [openCreate, setOpenCreate] = useState(false);
    const [openPermis, setOpenPermis] = useState(false);
    const [opentest, setOpentest] = useState(false);
    const [openFile, setOpenFile] = useState(false);
    const [openUploadFile, setOpenUploadFile] = useState(false);
    const [openDialogIndex, setOpenDialogIndex] = useState<boolean>(false);

    const handleClickOpenCreate = () => {
        setOpenCreate(true);

    };
    const handleCloseCreate = () => {
        setOpenCreate(false);
        clearErrorMessage();
        setInputFolder({
            folderName: '',
            ...inputFolder
        })
    };
    const handleClickOpenPermis = () => {
        setOpenPermis(true);
    };
    const handleClosePermis = () => {
        setOpenPermis(false);
    };
    const handleStepUpdate = (item: any, id: number) => {
        setStep((prevData: any) => {
            const newData = [...prevData];
            newData[id] = item
            return newData;
        });
    }

    const loadData = useCallback(async () => {
        let condition: any = {};
        if (sdate) condition = { ...condition, startDate: sdate };
        if (edate) condition = { ...condition, endDate: edate };
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear === 'all' ? '' : idFiscalYear };
        if (keywordLevel1) condition = { ...condition, keywordLevel1: keywordLevel1 };
        if (keywordLevel2) condition = { ...condition, keywordLevel2: keywordLevel2 };
        if (keywordLevel3) condition = { ...condition, keywordLevel3: keywordLevel3 };
        if (keywordLevel4) condition = { ...condition, keywordLevel4: keywordLevel4 };
        if (sortBy) condition = { ...condition, sortBy: sortBy };
        if (sortType) condition = { ...condition, sortType: sortType };
        if (inputFolder?.idReferFolder) {
            if (inputFolder?.stepView === 2) {
                const res = await FolderApi.getSharedFolder(inputFolder.idReferFolder, condition)
                const data = await res.data.result;
                const newArray = new Array(level1?.indexOf(level1?.find((n: any) => n?.idFolder === step[0])))
                setLevel2([...newArray, ...(data?.detailFolders ? data?.detailFolders : [])])
                setLevelFiles([...newArray, ...(data?.detailFiles ? data?.detailFiles : [])])
            }
            if (inputFolder?.stepView === 3) {
                const res = await FolderApi.getSharedFolder(inputFolder.idReferFolder, condition)
                const data = await res.data.result;
                const newArray = new Array(level2?.indexOf(level2?.find((n: any) => n?.idFolder === step[1])))
                setLevel3([...newArray, ...(data?.detailFolders ? data?.detailFolders : [])])
                setLevelFiles([...newArray, ...(data?.detailFiles ? data?.detailFiles : [])])
            }
            if (inputFolder?.stepView === 4) {
                const res = await FolderApi.getSharedFolder(inputFolder.idReferFolder, condition)
                const data = await res.data.result;
                const newArray = new Array(level3?.indexOf(level3?.find((n: any) => n?.idFolder === step[2])))
                setLevel4([...newArray, ...(data?.detailFolders ? data?.detailFolders : [])])
                setLevelFiles([...newArray, ...(data?.detailFiles ? data?.detailFiles : [])])
            }
            if (inputFolder?.stepView === 5) {
                const res = await FolderApi.getSharedFolder(inputFolder.idReferFolder, condition)
                const data = await res.data.result;
                const newArray = new Array(inputFolder.layer)
                setLevelFiles([...newArray, ...(data?.detailFiles ? data?.detailFiles : [])])
            }
        } else {
            await FolderApi.getSharedFolders(condition).then((res) => {
                if (res?.data?.success) {
                    const data = res.data.result;
                    const dataLevel1 = data.detailFolders

                    setLevel1(dataLevel1);
                    setLevelFiles(data?.detailFiles)
                    if (keywordLevel1) {
                        if (dataLevel1[0]) {
                            const dataLevel2 = dataLevel1[0].detailFolders
                            const idLevel2 = dataLevel1[0].idFolder
                            setLevel2(dataLevel2)
                            setLevelFiles(dataLevel1[0]?.detailFiles)
                            handleStepUpdate(idLevel2, 0)
                            setInputFolder({ ...inputFolder, idReferFolder: idLevel2, layer: 0, stepView: 2 })

                        } else {
                            setLevel2(null)
                            setLevel3(null)
                            setLevel4(null)
                            handleStepUpdate(0, 1)
                            handleStepUpdate(0, 2)
                            handleStepUpdate(0, 3)
                            handleStepUpdate(0, 4)
                        }
                    }
                    else if (keywordLevel4) {
                        if (dataLevel1[0]) {
                            const dataLevel2 = dataLevel1[0].detailFolders
                            const idLevel2 = dataLevel1[0].idFolder
                            setLevel2(dataLevel2)
                            setLevelFiles(dataLevel1[0]?.detailFiles)
                            handleStepUpdate(idLevel2, 0)
                            setInputFolder({ ...inputFolder, idReferFolder: idLevel2, layer: 0, stepView: 2 })
                            if (dataLevel2[0]) {
                                const dataLevel3 = dataLevel2[0].detailFolders
                                const idLevel3 = dataLevel2[0].idFolder
                                setLevel3(dataLevel3)
                                setLevelFiles(dataLevel2[0]?.detailFiles)
                                handleStepUpdate(idLevel3, 1)
                                setInputFolder({ ...inputFolder, idReferFolder: idLevel3, layer: 0, stepView: 3 })
                                if (dataLevel3[0]) {
                                    const dataLevel4 = dataLevel3[0].detailFolders
                                    const idLevel4 = dataLevel3[0].idFolder
                                    setLevel4(dataLevel4)
                                    setLevelFiles(dataLevel3[0]?.detailFiles)
                                    handleStepUpdate(idLevel4, 2)
                                    setInputFolder({ ...inputFolder, idReferFolder: idLevel4, layer: 0, stepView: 4 })
                                    if (dataLevel4[0]) {
                                        const dataFiles = dataLevel4[0].detailFiles
                                        // const idLevel4 = dataLevel3[0].idFolder
                                        setLevelFiles(dataFiles)
                                        handleStepUpdate(dataLevel4[0]?.idFolder, 3)
                                        setInputFolder({ ...inputFolder, idReferFolder: dataLevel4[0]?.idFolder, layer: 0, stepView: 5 })
                                        if (dataFiles[0]) {
                                            handleStepUpdate(dataFiles[0]?.idFile, 4)
                                        } else {
                                            setLevelFiles(null)
                                            handleStepUpdate(0, 4)
                                        }
                                    } else {
                                        setLevelFiles(null)
                                        handleStepUpdate(0, 4)
                                    }
                                } else {
                                    setLevel4(null)
                                    handleStepUpdate(0, 3)
                                    handleStepUpdate(0, 4)
                                }
                            } else {
                                setLevel3(null)
                                setLevel4(null)
                                handleStepUpdate(0, 2)
                                handleStepUpdate(0, 3)
                                handleStepUpdate(0, 4)
                            }
                        } else {
                            setLevel2(null)
                            setLevel3(null)
                            setLevel4(null)
                            handleStepUpdate(0, 1)
                            handleStepUpdate(0, 2)
                            handleStepUpdate(0, 3)
                            handleStepUpdate(0, 4)
                        }
                    }
                    else if (keywordLevel3) {
                        if (dataLevel1[0]) {
                            const dataLevel2 = dataLevel1[0].detailFolders
                            const idLevel2 = dataLevel1[0].idFolder
                            setLevel2(dataLevel2)
                            setLevelFiles(dataLevel1[0]?.detailFiles)
                            handleStepUpdate(idLevel2, 0)
                            setInputFolder({ ...inputFolder, idReferFolder: idLevel2, layer: 0, stepView: 2 })
                            if (dataLevel2[0]) {
                                const dataLevel3 = dataLevel2[0].detailFolders
                                const idLevel3 = dataLevel2[0].idFolder
                                setLevel3(dataLevel3)
                                setLevelFiles(dataLevel2[0]?.detailFiles)
                                handleStepUpdate(idLevel3, 1)
                                setInputFolder({ ...inputFolder, idReferFolder: idLevel3, layer: 0, stepView: 3 })
                                if (dataLevel3[0]) {
                                    const dataLevel4 = dataLevel3[0].detailFolders
                                    const idLevel4 = dataLevel3[0].idFolder
                                    setLevel4(dataLevel4)
                                    setLevelFiles(dataLevel3[0]?.detailFiles)
                                    handleStepUpdate(idLevel4, 2)
                                    setInputFolder({ ...inputFolder, idReferFolder: idLevel4, layer: 0, stepView: 4 })

                                } else {
                                    setLevel4(null)
                                    handleStepUpdate(0, 3)
                                    handleStepUpdate(0, 4)
                                }
                            } else {
                                setLevel3(null)
                                setLevel4(null)
                                handleStepUpdate(0, 2)
                                handleStepUpdate(0, 3)
                                handleStepUpdate(0, 4)
                            }
                        } else {
                            setLevel2(null)
                            setLevel3(null)
                            setLevel4(null)
                            handleStepUpdate(0, 1)
                            handleStepUpdate(0, 2)
                            handleStepUpdate(0, 3)
                            handleStepUpdate(0, 4)
                        }
                    }
                    else if (keywordLevel2) {
                        if (dataLevel1[0]) {
                            const dataLevel2 = dataLevel1[0].detailFolders
                            const idLevel2 = dataLevel1[0].idFolder
                            setLevel2(dataLevel2)
                            setLevelFiles(dataLevel1[0]?.detailFiles)
                            handleStepUpdate(idLevel2, 0)
                            setInputFolder({ ...inputFolder, idReferFolder: idLevel2, layer: 0, stepView: 2 })
                            if (dataLevel2[0]) {
                                const dataLevel3 = dataLevel2[0].detailFolders
                                const idLevel3 = dataLevel2[0].idFolder
                                setLevel3(dataLevel3)
                                setLevelFiles(dataLevel2[0]?.detailFiles)
                                handleStepUpdate(idLevel3, 1)
                                setInputFolder({ ...inputFolder, idReferFolder: idLevel3, layer: 0, stepView: 3 })

                            } else {
                                setLevel3(null)
                                setLevel4(null)
                                handleStepUpdate(0, 2)
                                handleStepUpdate(0, 3)
                                handleStepUpdate(0, 4)
                            }
                        } else {
                            setLevel2(null)
                            setLevel3(null)
                            setLevel4(null)
                            handleStepUpdate(0, 1)
                            handleStepUpdate(0, 2)
                            handleStepUpdate(0, 3)
                            handleStepUpdate(0, 4)
                        }
                    }
                    else if (keywordLevel1) {
                        if (dataLevel1[0]) {
                            const dataLevel2 = dataLevel1[0].detailFolders
                            const idLevel2 = dataLevel1[0].idFolder
                            setLevel2(dataLevel2)
                            setLevelFiles(dataLevel1[0]?.detailFiles)
                            handleStepUpdate(idLevel2, 0)
                            setInputFolder({ ...inputFolder, idReferFolder: idLevel2, layer: 0, stepView: 2 })

                        } else {
                            setLevel2(null)
                            setLevel3(null)
                            setLevel4(null)
                            handleStepUpdate(0, 1)
                            handleStepUpdate(0, 2)
                            handleStepUpdate(0, 3)
                            handleStepUpdate(0, 4)
                        }
                    }
                }
            });
        }


    }, [sortBy, sortType, keywordLevel1, keywordLevel2, keywordLevel3, keywordLevel4, sdate, edate, idFiscalYear, inputFolder?.idReferFolder, inputFolder?.stepView, inputFolder.layer]);

    const loadDataLevel = async (idFolder: number) => {
        const res = await FolderApi.getSharedFolder(idFolder)
        const data = await res.data;
        if (data?.success) {
            return data.result
        }
    }

    useEffect(() => {
        if (folderPath?.length > 0) {
            if (folderPath[0]) {
                const loadDataLevel = async () => {
                    const res = await FolderApi.getSharedFolder(folderPath[0])
                    const data = await res.data;
                    if (data?.success) {
                        setLevel1([data.result])
                    }
                }
                loadDataLevel()

            } else {
                setLevel1(null)
            }
            if (folderPath[1]) {
                const loadDataLevel = async () => {
                    const res = await FolderApi.getSharedFolder(folderPath[1])
                    const data = await res.data;
                    if (data?.success) {
                        setLevel2([data.result])
                    }
                }
                loadDataLevel()

            } else {
                setLevel2(null)
            }
            if (folderPath[2]) {
                const loadDataLevel = async () => {
                    const res = await FolderApi.getSharedFolder(folderPath[2])
                    const data = await res.data;
                    if (data?.success) {
                        setLevel3([data.result])
                    }
                }
                loadDataLevel()

            } else {
                setLevel3(null)
            }
            if (folderPath[3]) {
                const loadDataLevel = async () => {
                    const res = await FolderApi.getSharedFolder(folderPath[3])
                    const data = await res.data;
                    if (data?.success) {
                        setLevel4([data.result])
                    }
                }
                loadDataLevel()

            } else {
                setLevel4(null)
            }
            if (folderPath[4]) {
                const loadDataLevel = async () => {
                    const res = await FolderApi.getSharedFolder(folderPath[4])
                    const data = await res.data;
                    if (data?.success) {
                        setLevelFiles([data.result])
                    }
                }
                loadDataLevel()

            } else {
                setLevelFiles(null)
            }
        }


    }, [folderPath])
    const loadFolderName = async () => {
        const res = await FolderApi.getFolderName()
        const data = await res.data;
        if (data?.success) {
            setFolderName(data.result)
        }
    }

    useEffect(() => {
        loadData()
    }, [loadData])

    useEffect(() => {
        loadFolderName()
    }, [])

    const createFolder = async () => {
        if (!inputFolder.folderName)
            return setErrorMessage({
                ...errorMessage,
                ...{ FOLDERNAME: `กรุณากรอกชื่อ${inputFolder?.stepView === 1 ? 'ตู้' : inputFolder?.stepView === 2 ? 'ชั้น' : inputFolder?.stepView === 3 ? 'แฟ้ม' : inputFolder?.stepView === 4 ? 'ประเภท' : ''}` },
            });
        setLoading(true)
        const data = {
            folderName: inputFolder.folderName || '',
            folderLocation: inputFolder.folderLocation || '',
            idReferFolder: inputFolder.idReferFolder || null,
            idDepartment: profile.idDepartment,
            idFiscalyear: new Date().getFullYear() + 543
        }
        if (inputFolder.idFolder) {
            await FolderApi.patchFolder(inputFolder.idFolder, data).then(async (res) => {
                if (res?.data?.success) {
                    if (inputFolder?.stepView === 1) {
                        const data = await loadDataLevel(res?.data?.result?.idFolder)
                        setLevel1(level1.map((x: any) => {
                            x = x.idFolder === res?.data?.result?.idFolder ? data : x
                            return x
                        }));

                    }
                    if (inputFolder?.stepView === 2) {
                        const data = await loadDataLevel(inputFolder.idReferFolder)
                        const newArray = new Array(inputFolder.layer)
                        setLevel2([...newArray, ...data.detailFolders])
                    }
                    if (inputFolder?.stepView === 3) {
                        const data = await loadDataLevel(inputFolder.idReferFolder)
                        const newArray = new Array(inputFolder.layer)
                        setLevel3([...newArray, ...data.detailFolders])
                    }
                    if (inputFolder?.stepView === 4) {
                        const data = await loadDataLevel(inputFolder.idReferFolder)
                        const newArray = new Array(inputFolder.layer)
                        setLevel4([...newArray, ...data.detailFolders])
                    }
                    if (inputFolder?.stepView === 5) {
                        const data = await loadDataLevel(inputFolder.idReferFolder)
                        const newArray = new Array(inputFolder.layer)
                        setLevelFiles([...newArray, ...data.detailFiles])
                    }
                    // loadData()
                    setLoading(false)
                    setOpenCreate(false)
                    swalSuccess(`อัพเดท${inputFolder?.stepView === 1 ? 'ตู้' : inputFolder?.stepView === 2 ? 'ชั้น' : inputFolder?.stepView === 3 ? 'แฟ้ม' : inputFolder?.stepView === 4 ? 'ประเภท' : ''}สำเร็จ`)
                    setInputFolder({
                        folderName: '',
                        folderLocation: '',
                        idFiscalYear: null,
                        idDepartment: null,
                    })
                } else {
                    setLoading(false)
                    setOpenCreate(false)
                    swalError(res.response.data.description || res.response.data.message);
                    setInputFolder({
                        folderName: '',
                        folderLocation: '',
                        idFiscalYear: null,
                        idDepartment: null,
                    })
                }


            }).catch((error: any) => {
                setLoading(false)
                setOpenCreate(false)
                swalError(error.response.data.description || error.response.data.message);
            })
        } else {
            await FolderApi.postFolder(data).then(async (res) => {
                if (res?.data?.success) {
                    if (inputFolder?.stepView === 1) {
                        const data = await loadDataLevel(res?.data?.result?.idFolder)
                        const newArray = new Array(inputFolder.layer)
                        setLevel1([
                            data,
                            ...level1
                        ])
                        loadData()
                    }
                    if (inputFolder?.stepView === 2) {
                        const data = await loadDataLevel(inputFolder.idReferFolder)
                        const newArray = new Array(inputFolder.layer)

                        setLevel2([
                            ...newArray,
                            ...data.detailFolders,
                        ])
                    }
                    if (inputFolder?.stepView === 3) {
                        const data = await loadDataLevel(inputFolder.idReferFolder)
                        const newArray = new Array(inputFolder.layer)

                        setLevel3([
                            ...newArray,
                            ...data.detailFolders,
                        ])
                    }
                    if (inputFolder?.stepView === 4) {
                        const data = await loadDataLevel(inputFolder.idReferFolder)
                        const newArray = new Array(inputFolder.layer)

                        setLevel4([
                            ...newArray,
                            ...data.detailFolders,
                        ])
                    }
                    if (inputFolder?.stepView === 5) {
                        const data = await loadDataLevel(res?.data?.result?.idFolder)
                        const newArray = new Array(inputFolder.layer)

                        setLevelFiles([...newArray, ...data])
                    }
                    setLoading(false)
                    setOpenCreate(false)
                    swalSuccess(`สร้าง${inputFolder?.stepView === 1 ? 'ตู้' : inputFolder?.stepView === 2 ? 'ชั้น' : inputFolder?.stepView === 3 ? 'แฟ้ม' : inputFolder?.stepView === 4 ? 'ประเภท' : ''}สำเร็จ`)
                    setInputFolder({
                        folderName: '',
                        folderLocation: '',
                        idFiscalYear: null,
                        idDepartment: null,
                    })
                } else {
                    setLoading(false)
                    setOpenCreate(false)
                    swalError(res.response.data.description || res.response.data.message);
                    setInputFolder({
                        folderName: '',
                        folderLocation: '',
                        idFiscalYear: null,
                        idDepartment: null,
                    })
                }

            }).catch((error: any) => {
                setLoading(false)
                setOpenCreate(false)
                swalError(error.response.data.description || error.response.data.message);
            })
        }
    }
    const createFile = async () => {

        setLoadingFile(true)
        const formData = new FormData();

        files.forEach((item: any) => {
            formData.append("file", item.file)
            const { file, ...remain } = item
            formData.append("info", JSON.stringify(remain))
        })

        const idFolder = inputFolder.idReferFolder

        await FileApi.postFileInFolder(idFolder, formData).then(async (res) => {
            if (res?.data?.success) {
                // if (stepView === 1) {
                //     const data = await loadDataLevel(inputFolder.idReferFolder)
                //     setLevel1(data)
                // }
                // if (stepView === 2) {
                //     const data = await loadDataLevel(inputFolder.idReferFolder)
                //     setLevel2(data)
                // }
                // if (stepView === 3) {
                //     const data = await loadDataLevel(inputFolder.idReferFolder)
                //     setLevel3(data)
                // }
                // if (stepView === 4) {
                //     const data = await loadDataLevel(inputFolder.idReferFolder)
                //     setLevel4(data)
                // }
                // if (stepView === 5) {
                const data = await loadDataLevel(inputFolder.idReferFolder)
                const newArray = new Array(inputFolder.layer)

                setLevelFiles([...newArray, ...data.detailFiles])
                // }
                // loadData()
                setLoadingFile(false)
                setOpenUploadFile(false)
                swalSuccess('สร้างไฟล์สำเร็จ')
            } else {
                setLoadingFile(false)
                setOpenUploadFile(false)
                swalError(res.response.data.description || res.response.data.message);
            }

        }).catch((error: any) => {
            setLoadingFile(false)
            setOpenCreate(false)
            swalError(error.response.data.description || error.response.data.message);
        })
    }

    const bulkFileDownload = async () => {
        const ids = levelfiles?.filter((x: any) => x?.check === true).map((x: any) => x.idFile).join(',')
        const res = await FileApi.getBulkFileDownload(ids)
        const blob = new Blob([res.data], { type: 'application/zip' },);
        const url = window.URL.createObjectURL(blob)
        saveAs(url, 'files')
    }
    const bulkFileDelete = async () => {
        swalActive(
            `ยืนยันที่จะลบหรือไม่?`,
            null, async (res: any) => {
                if (res) {
                    const ids = levelfiles?.filter((x: any) => x?.check === true).map((x: any) => x.idFile).join(',')
                    const res = await FileApi.getBulkFileDelete(ids)
                    if (res?.data?.success) {
                        swalSuccess('ลบสำเร็จ')
                        loadData()
                    }
                }
            })
    }
    return (
        <LayoutView>
            <LayoutTitle sx={{ display: { md: 'flex', xs: 'block' } }}>
                <div className='d-flex'>
                    {viewType !== 'column' ? <>
                        <Breadcrumbs maxItems={2} aria-label="breadcrumb">
                            {inputFolder?.stepView >= 1 && <TitleText style={{ cursor: 'pointer' }} className='title' onClick={async () => {
                                setLevel2(null)
                                setLevel3(null)
                                setLevel4(null)
                                setLevelFiles([])
                                setInputFolder({ ...inputFolder, idReferFolder: null, stepView: 1, permissionLevel: null, permitLevel: permit?.find((x: any) => x?.code === 'Level1.Add')?.permit, permitUpload: permit?.find((x: any) => x?.code === 'upload.Add')?.permit })
                                handleStepUpdate(0, 0)
                                handleStepUpdate(0, 1)
                                handleStepUpdate(0, 2)
                                handleStepUpdate(0, 3)
                                handleStepUpdate(0, 4)
                            }}>ตู้เอกสารที่แชร์กับฉัน</TitleText>}
                            {inputFolder?.stepView >= 2 && <TitleText style={{ cursor: 'pointer' }} className='title' onClick={async () => {
                                const data = await loadDataLevel(step[0])
                                const newArray = new Array(level1?.indexOf(level1?.find((n: any) => n?.idFolder === step[0])))
                                setInputFolder({ ...inputFolder, idReferFolder: step[0], stepView: 2, permissionLevel: data?.permissionLevel, permitLevel: permit?.find((x: any) => x?.code === 'Level2.Add')?.permit, permitUpload: permit?.find((x: any) => x?.code === 'upload.Add')?.permit })

                                setLevelFiles([...newArray, ...data?.detailFiles])
                                setLevel2([...newArray, ...data?.detailFolders])
                                setLevel3(null)
                                setLevel4(null)
                                handleStepUpdate(0, 1)
                                handleStepUpdate(0, 2)
                                handleStepUpdate(0, 3)
                                handleStepUpdate(0, 4)
                            }}><icons.Building style={{ margin: '0px 5px' }} /> {level1?.find((x: any) => x?.idFolder === step[0])?.folderName}</TitleText>}
                            {inputFolder?.stepView >= 3 && <TitleText style={{ cursor: 'pointer' }} className='title' onClick={async () => {
                                const data = await loadDataLevel(step[1])
                                const newArray = new Array(level2?.indexOf(level2?.find((n: any) => n?.idFolder === step[1])))
                                setInputFolder({ ...inputFolder, idReferFolder: step[1], stepView: 3, permissionLevel: data?.permissionLevel, permitLevel: permit?.find((x: any) => x?.code === 'Level3.Add')?.permit, permitUpload: permit?.find((x: any) => x?.code === 'upload.Add')?.permit })

                                setLevel3([...newArray, ...data?.detailFolders])
                                setLevelFiles([...newArray, ...data?.detailFiles])
                                handleStepUpdate(0, 2)
                                handleStepUpdate(0, 3)
                                handleStepUpdate(0, 4)
                                setLevel4(null)
                            }}><icons.listFolder style={{ margin: '0px 5px' }} /> {level2?.find((x: any) => x?.idFolder === step[1])?.folderName}</TitleText>}
                            {inputFolder?.stepView >= 4 && <TitleText style={{ cursor: 'pointer' }} className='title' onClick={async () => {

                                const data = await loadDataLevel(step[2])
                                const newArray = new Array(level3?.indexOf(level3?.find((n: any) => n?.idFolder === step[2])))
                                setInputFolder({ ...inputFolder, idReferFolder: step[2], stepView: 4, permissionLevel: data?.permissionLevel, permitLevel: permit?.find((x: any) => x?.code === 'Level4.Add')?.permit, permitUpload: permit?.find((x: any) => x?.code === 'upload.Add')?.permit })

                                setLevel4([...newArray, ...data?.detailFolders])
                                setLevelFiles([...newArray, ...data?.detailFiles])
                                handleStepUpdate(0, 3)
                                handleStepUpdate(0, 4)
                            }}><icons.Folder style={{ margin: '0px 5px' }} />{level3?.find((x: any) => x?.idFolder === step[2])?.folderName}</TitleText>}
                            {inputFolder?.stepView === 5 && <TitleText style={{ cursor: 'pointer' }} className='title' onClick={async () => {
                                const data = await loadDataLevel(step[3])
                                const newArray = new Array(inputFolder.layer)
                                setLevelFiles([...newArray, ...data?.detailFiles])
                            }}><icons.double style={{ margin: '0px 5px' }} />{level4?.find((x: any) => x?.idFolder === step[3])?.folderName}</TitleText>}
                        </Breadcrumbs>
                    </>
                        :
                        <TitleText className='title'>ตู้เอกสารที่แชร์กับฉัน</TitleText>
                    }
                </div>
                <MenuButtom
                    handleClickOpenPermis={handleClickOpenPermis}
                    inputFolder={inputFolder}
                    handleClickOpenCreate={handleClickOpenCreate}
                    setOpenUploadFile={setOpenUploadFile}
                    setOpenFilter={setOpenFilter}
                    levelfiles={levelfiles}
                    bulkFileDelete={bulkFileDelete}
                    bulkFileDownload={bulkFileDownload}
                    setOpenDialogIndex={setOpenDialogIndex}
                    type='shred'
                />

            </LayoutTitle>
            <FilterFolder
                folderName={folderName}
                sdate={sdate}
                setSdate={setSdate}
                edate={edate}
                setEdate={setEdate}
                inputFolder={inputFolder}
                setInputFolder={setInputFolder}
                setLevel2={setLevel2}
                setLevel3={setLevel3}
                setLevel4={setLevel4}
                setLevelFiles={setLevelFiles}
                keywordLevel1={keywordLevel1}
                setKeywordLevel1={setKeywordLevel1}
                keywordLevel2={keywordLevel2}
                setKeywordLevel2={setKeywordLevel2}
                keywordLevel3={keywordLevel3}
                setKeywordLevel3={setKeywordLevel3}
                keywordLevel4={keywordLevel4}
                setKeywordLevel4={setKeywordLevel4}
                idFiscalYear={idFiscalYear}
                setIdFiscalYear={setIdFiscalYear}
            />
            <Box sx={{ display: { lg: "flex", xs: 'block' }, justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', marginBottom: '12px', alignItems: "center", justifyContent: { lg: 'flex-start', xs: 'space-between' } }}>
                    {levelfiles?.filter((x: any) => x?.idFile)?.length > 0 && <>
                        <ButtonCustom variant={'outlined'}
                            startIcon={<icons.checkboxButton />}
                            textButton={'เลือกทั้งหมด'}
                            onClick={() => {
                                setLevelFiles(
                                    [...levelfiles?.filter((x: any) => !x?.idFile),
                                    ...levelfiles?.filter((x: any) => x?.idFile)?.map((x: any) => {
                                        x.check = !x?.check
                                        return x
                                    })]
                                )
                            }}
                            style={{ marginRight: '8px', }}
                            btnStyle={{
                                '&.MuiButton-outlined': {
                                    color: `#323539 !important`,
                                    border: `2px solid #E5E5E7 !important`,
                                    borderRadius: "10px !important",
                                    '&:hover': {
                                        color: `#323539  !important`,
                                        border: `2px solid #E5E5E7 !important`,
                                        backgroundColor: '#EFFFF7 !important'
                                    },
                                },
                            }} />
                        <Typography>จำนวนรายการที่เลือก : {levelfiles?.filter((x: any) => x?.check === true)?.length || 0}</Typography>
                    </>
                    }
                </Box>
                <Box sx={{ display: "flex", alignItems: 'center', marginBottom: '12px', }}>
                    <Typography style={{ whiteSpace: 'nowrap', marginRight: "10px" }}>เรียงตาม :</Typography>
                    <FilterSelect heading='' labelId='' selectId='' options={[
                        { value: 'NAME_ASC', name: 'ชื่อจาก น้อย-มาก' },
                        { value: 'NAME_DESC', name: 'ชื่อจาก มาก-น้อย' },
                        { value: 'DATE_ASC', name: 'วันที่จาก น้อย-มาก' },
                        { value: 'DATE_DESC', name: 'วันที่จาก มาก-น้อย' },

                    ].map((x, i) => {
                        return (
                            <MenuItem key={i}
                                value={x.value}
                            >
                                {x.name}
                            </MenuItem>
                        )
                    })} value={sort} style={{ width: '140px' }} onchange={(e: any) => {
                        setSort(e.target.value)
                        setSortBy(e.target.value.includes('NAME') ? 'name' : 'createDate')
                        setSortType(e.target.value.includes('ASC') ? 'ASC' : 'DESC')
                    }} />
                    <Divider orientation="vertical" variant="middle" flexItem sx={{ margin: '0px 12px', borderColor: '#878787' }} />
                    <div style={{ display: "flex", alignItems: 'center', gap: '8px' }}>

                        <FormatListBulletedIcon sx={{ cursor: "pointer", color: viewType !== 'column' ? '#858C95' : '#026735', fontSize: '18px' }} onClick={() => setViewType('column')} />
                        <GridViewIcon sx={{ cursor: "pointer", color: viewType === 'column' ? '#858C95' : '#026735', fontSize: '18px' }} onClick={() => setViewType('box')} />
                    </div>
                    <Divider orientation="vertical" variant="middle" flexItem sx={{ margin: '0px 12px', borderColor: '#878787' }} />

                    {inputFolder?.idReferFolder && <ErrorOutlineIcon style={{ cursor: "pointer", fontSize: '18px', color: '#858C95' }} onClick={() => setOpentest(true)} />}

                </Box>
            </Box>
            <Folder
                step={step}
                viewType={viewType}
                level1={level1}
                level2={level2}
                level3={level3}
                level4={level4}
                setLevel1={setLevel1}
                setLevel2={setLevel2}
                setLevel3={setLevel3}
                setLevel4={setLevel4}
                setLevelFiles={setLevelFiles}
                setFile={setFile}
                setOpenFile={setOpenFile}
                levelfiles={levelfiles}
                inputFolder={inputFolder}
                setInputFolder={setInputFolder}
                handleStepUpdate={handleStepUpdate}
                loadData={loadData}
                loadDataLevel={loadDataLevel}
                handleClickOpenCreate={handleClickOpenCreate}
                permit={permit} />
            <DialogCreate
                openCreate={openCreate}
                handleCloseCreate={handleCloseCreate}
                value={inputFolder}
                setInput={setInputFolder}
                clearErrorMessage={clearErrorMessage}
                errorMessage={errorMessage}
                submit={createFolder}
                loading={loading}
                stepView={inputFolder?.stepView}
            />

            <DialogOpenFile
                openFile={openFile}
                setOpenFile={setOpenFile}
                file={file}
                setFile={setFile}
                inputFolder={inputFolder}
                loadDataLevel={loadDataLevel}
                setLevelFiles={setLevelFiles} />

            <DialogPermis openPermis={openPermis} handleClosePermis={handleClosePermis} idFolder={inputFolder.idReferFolder} loadData={loadData} />

            <DialogUpload
                loading={loadingFile}
                submit={createFile}
                file={files}
                setFile={setFiles}
                openUploadFile={openUploadFile}
                setOpenUploadFile={setOpenUploadFile}
                idFolder={inputFolder.idReferFolder}
                type='Shared' />

            <DialogDetail open={opentest} handleClose={setOpentest} idFolder={inputFolder.idReferFolder} />

            <DialogFilter openFilter={openFilter} setOpenFilter={setOpenFilter}
                sdate={sdate}
                setSdate={setSdate}
                edate={edate}
                setEdate={setEdate}
                keywordLevel1={keywordLevel1}
                keywordLevel2={keywordLevel2}
                keywordLevel3={keywordLevel3}
                keywordLevel4={keywordLevel4}
                setKeywordLevel1={setKeywordLevel1}
                setKeywordLevel2={setKeywordLevel2}
                setKeywordLevel3={setKeywordLevel3}
                setKeywordLevel4={setKeywordLevel4}
                setIdFiscalYear={setIdFiscalYear}
                idFiscalYear={idFiscalYear}
                folderName={folderName}
            />
            <DialogIndex openDialog={openDialogIndex} setOpenDialog={setOpenDialogIndex} inputFolder={inputFolder} loadData={loadData} loadDataLevel={loadDataLevel} level1={level1} setLevel1={setLevel1} setLevel2={setLevel2} setLevel3={setLevel3} setLevel4={setLevel4} setLevelFiles={setLevelFiles} />

        </LayoutView >
    )
}
